import React from "react";

import { Card, CardProps } from "@material-ui/core";

export interface CustomCardProps extends CardProps {

}

export default function CustomCard(props: CustomCardProps) {

  const { children, style, ...rest } = props;

  return (
    <Card {...rest} style={{ marginTop: 10, marginBottom: 10, overflow: 'visible', ...style }}>
      {children}
    </Card>
  );
}

